import { render, staticRenderFns } from "./starRating.vue?vue&type=template&id=365150da&scoped=true&"
import script from "./starRating.vue?vue&type=script&lang=js&"
export * from "./starRating.vue?vue&type=script&lang=js&"
import style0 from "./starRating.vue?vue&type=style&index=0&id=365150da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365150da",
  null
  
)

export default component.exports